import { STD_CATS } from "../constants";
import { today } from "./formatters";

export const currentMonthKey = () => today().slice(0,7);
export const monthLabel = key => new Date(`${key}-01T00:00:00`).toLocaleDateString("en-IN",{month:"long",year:"numeric"});

export const toMoneyNumber = value => {
  const n = parseFloat(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

export const getBudgetForMonth = (account, key=currentMonthKey()) => {
  const saved = account?.budgets?.[key] || {};
  return {
    monthly: toMoneyNumber(saved.monthly),
    categories: saved.categories || {}
  };
};

export const buildBudgetStats = (account, txns, key=currentMonthKey()) => {
  const budget = getBudgetForMonth(account, key);
  const monthExpenses = txns.filter(t => t.type === "expense" && (t.date || "").slice(0,7) === key);
  const spent = monthExpenses.reduce((sum,t)=>sum + (Number(t.amount)||0),0);
  const catSpent = {};
  monthExpenses.forEach(t => { catSpent[t.category || "Other"] = (catSpent[t.category || "Other"] || 0) + (Number(t.amount)||0); });
  const categoryStats = STD_CATS.expense.map(c => {
    const limit = toMoneyNumber(budget.categories?.[c.l]);
    const used = catSpent[c.l] || 0;
    return { category:c.l, icon:c.icon, limit, used, remaining:limit-used, pct:limit>0?Math.min(100,(used/limit)*100):0 };
  }).filter(c => c.limit > 0 || c.used > 0).sort((a,b)=>(b.limit||b.used)-(a.limit||a.used));
  return {
    key,
    budget,
    spent,
    remaining: budget.monthly - spent,
    pct: budget.monthly > 0 ? Math.min(100,(spent/budget.monthly)*100) : 0,
    categoryStats
  };
};
